
    import {Component, Vue, Watch} from "vue-property-decorator";
    import statisticApi from "@/api/statistic";

    const {CodeToText, regionData} = require("@/js/region/region");
    import {dictApi} from "@/api/organization";
    import utils from "@/common/utils"

    @Component({
        name: "Audit_Index",
    })
    export default class Home extends Vue {
        mode = 'Audit_Order'; // or Audit_Instr  备案申请  或 器具备案
        dataList = []; //数据列表
        CodeToText = CodeToText;
        regionData = regionData;
        levelData = {};
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        mechanismLevelList = [];
        propParam = {
            mechanismName: '', //部门名称
            mechanismLevel: '', //部门级别
            mechanismRegion: '', //所属区域
            startTime: '', //起始日期
            endTime: '', //结束日期
        } as any
        loading = false;
        showForm = false;
        private exportExcel: any;

        mounted() {
            //单位级别
            dictApi.listDictItem({typeCode: "dwjb"}).then((r) => {
                if (r.data.result === 0) {
                    const levels = r.data.data;
                    this.mechanismLevelList = levels;
                    this.levelData = Object.fromEntries(levels.map((item: any) => [item.dictKey, item]));
                }
            });
            //单位区域
            // statisticApi.getMechanismRegion().then((r) => {
            //     const regionCode = r.data.data;
            //     if(regionCode == null){
            //         this.regionData = regionData;
            //     }else{
            //         const region = this.getRegionData(regionCode, regionData);
            //         this.regionData = [ region ];
            //     }
            // });
            this.loadDataList(null);
        }
        refresh(){
            this.loadDataList(null);
        }
        sortByFinishRate(a: any, b: any){
            return utils.numToFixed((a.finishCount / a.receiveCount) * 100) - utils.numToFixed((b.finishCount / b.receiveCount) * 100);
        }
        getRegionData(regionCode: number, projectList: any) : any{
            for (let i = 0; i < projectList.length; i++) {
                let treeItem= projectList[i]
                if(treeItem.value === regionCode ){
                    return treeItem
                }else{
                    if(treeItem.children && treeItem.children.length>0){
                        const res = this.getRegionData(regionCode, treeItem.children);
                        if(res){
                            return res;
                        }
                    }
                }
            }
        }

        // getRegionData(regionCode: number, projectList: any) : any{
        //     for (let i = 0; i < projectList.length; i++) {
        //         const project = projectList[i];
        //         if (project.children != null) {
        //             const r = this.getRegionData(regionCode, project.children);
        //             if (r != null) {
        //                 return r;
        //             }
        //         } else {
        //             if (project.value == regionCode) {
        //                return project;
        //             }
        //         }
        //     }
        // }

        reset(){
            for(const f in this.propParam){
                this.propParam[f] = "";
            }
            this.refresh();
        }
        loadDataList(callback: any) {
            this.loading = true;
            const params = {
                ...this.propParam,
            } as any;
            let api = statisticApi.listAuditOrderApp(params);
            api.then((r) => {
                if (r.data.result === 0) {
                    this.dataList = r.data.data;
                    this.$nextTick(() => {
                        if (callback) {
                            callback();
                        }
                    });
                }
                this.loading = false;
            });
        }

        onExportExcel() {
            const loading = this.$loading({
                text: '正在导出Excel',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.exportExcel(() => {
                loading.close();
            }, (this.mode == 'Audit_Order' ? '本区域各行政部门办理强检器具备案申请统计报表' : '本区域各行政部门办理强检器具备案统计报表') + ".xlsx");
        }
    }
